import styled from "@emotion/styled";

export const ZoomviewContainer = styled.div`
  box-shadow: 3px 3px 20px #919191;
  -moz-box-shadow: 3px 3px 20px #919191;
  -webkit-box-shadow: 3px 3px 20px #919191;
  margin: 24px 0 24px 0;
  line-height: 0;
  height: 266px;
  width: 100%;
`;

export const OverviewContainer = styled.div`
  box-shadow: 3px 3px 20px #919191;
  -moz-box-shadow: 3px 3px 20px #919191;
  -webkit-box-shadow: 3px 3px 20px #919191;
  margin: 0 0 24px 0;
  line-height: 0;
  height: 129px;
  width: 100%;
`;
